import { ArcElement, Chart } from "chart.js";
import React, { useEffect, useState } from "react";
import FarsightApi from "../../ApiWrapper";
import Box from "@mui/material/Box";
import { Line } from "react-chartjs-2";
import { Grow } from "@mui/material";
import dayjs from "dayjs";

Chart.register(ArcElement);
export default function PlayerEvolutionPerPatch(props: any) {
    const [rows, setRows] = useState([]);
    let props_copy: any = JSON.parse(JSON.stringify(props));
    props_copy.metrics = ["games", "performance", "winrate", "relative_performance", "date"];
    props_copy.patch = undefined;
    useEffect(() => {
        if (props.league !== "None") {
            setRows([]);
            FarsightApi.get_request("SimpleGroupby", props_copy).then((data) => {
                data = data.sort((a: any, b: any) => dayjs(a.date).unix() - dayjs(b.date).unix());
                setRows(data);
            });
        }
    }, [props.league, props.champion, props.server, props.year, props.picktype, props.leagues, props.role, props.year, props.target, props.player, props.accounts]);

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: "top" as const,
            },
            title: {
                display: true,
                text: `${props.player} evolution`,
            },
        },
        lineTension: 0.3,
    };

    console.log(rows);
    const data = {
        labels: rows.map((row: any) => row.patch),
        datasets: [
            {
                label: "Performance",
                data: rows.map((row: any) => row.performance),
                borderColor: "rgb(139, 42, 82)",
                backgroundColor: "rgba(139, 42, 82, 1)",
                pointRadius: 5,
                pointHoverRadius: 10,
            },
            {
                label: "Relative Performance",
                data: rows.map((row: any) => row.relative_performance),
                fill: false,
                borderColor: "#742774",
                pointRadius: 5,
                pointHoverRadius: 10,
            },
            {
                label: "0",
                data: rows.map((row: any) => 0),
                fill: false,
                borderColor: "#d81832",
                pointRadius: 0,
            },
        ],
    };

    return (
        <Grow in={true} style={{ transformOrigin: "0 -50 0" }} {...{ timeout: 2000 }}>
            <Box sx={{ width: "100%", height: "100%" }}>
                <Line options={options} data={data} />
            </Box>
        </Grow>
    );
}
